import {
  boxListButtonClass,
  boxListButtonSpanClass,
  boxListButtonTooltipTarget,
  boxListButtonTooltipText,
} from "@enums/boxListButtonCategories";

export const categoryMap = {
  create: {
    buttonClass: boxListButtonClass.Delete,
    spanClass: boxListButtonSpanClass.Create,
    tooltipTarget: boxListButtonTooltipTarget.Create,
    tooltipText: boxListButtonTooltipText.Create,
  },
  modify: {
    buttonClass: boxListButtonClass.Delete,
    spanClass: boxListButtonSpanClass.Modify,
    tooltipTarget: boxListButtonTooltipTarget.Modify,
    tooltipText: boxListButtonTooltipText.Modify,
  },
  delete: {
    buttonClass: boxListButtonClass.Delete,
    spanClass: boxListButtonSpanClass.Delete,
    tooltipTarget: boxListButtonTooltipTarget.Delete,
    tooltipText: boxListButtonTooltipText.Delete,
  },
  ban: {
    buttonClass: boxListButtonClass.Ban,
    spanClass: boxListButtonSpanClass.Ban,
    tooltipTarget: boxListButtonTooltipTarget.Ban,
    tooltipText: boxListButtonTooltipText.Ban,
  },
  verify: {
    buttonClass: boxListButtonClass.Verify,
    spanClass: boxListButtonSpanClass.Verify,
    tooltipTarget: boxListButtonTooltipTarget.Verify,
    tooltipText: boxListButtonTooltipText.Verify,
  },
  feature: {
    buttonClass: boxListButtonClass.Feature,
    spanClass: boxListButtonSpanClass.Feature,
    tooltipTarget: boxListButtonTooltipTarget.Feature,
    tooltipText: boxListButtonTooltipText.Feature,
  },
};
